module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_23.0eb6acdd.png";